// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"14e3092a","239":"6c773ddd","453":"d5b1d5ed","455":"5252629a","762":"9a07fc96"}[chunkId] + ".chunk.js";
};